import gift from '../../assests/images/coporateGifts.webp'
import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section className="relative">
  <motion.img
        src={gift}
        alt="Corporate gifting"
        className="w-full h-[620px] object-cover"
        initial={{ scale: 1.05, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      />

  {/* Bottom gradient */}
<motion.div
        className="absolute bottom-0 left-0 w-full h-[95%] bg-gradient-to-t from-[#92abc4]/100 to-transparent"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      />
  {/* Content */}
  <motion.div
        className=""
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.6,
          ease: "easeOut",
        }}
      >
  <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-center px-4 w-4/5 lg:max-w-3xl">
    <h1 className="text-yellow-400 text-3xl md:text-4xl font-bold">
      AN EFFORTLESS CORPORATE GIFTING JOURNEY
    </h1>

    <p className="text-white mt-4 text-lg">
      We design, source and deliver fully customised corporate gifts —
      tailored to your brand, audience and goals.
    </p>
  </div>
  </motion.div>
</section>

  );
}
